import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import PatientCard from "../../components/PaitientCard/PatientCard";
import { Link } from "react-router-dom";
import axios from "axios";
import styles from "../../../src/pages/console/Console.module.scss";
import PillNav from "../../components/PillNav/PillNav";

import { CheckToken } from "../../../src/pages/login/AccessToken";
import Dicom from "./Dicom";
const DicomMain = () => {
  const { state } = useLocation();
  console.log("Dicom main Page state", state);
  var stateVal = state;
  const [fhirArrays, setFhirArrays] = useState([]);
  const [data, setData] = useState(null);

  useEffect(() => {
    console.log("In dicom main");
    var fhirData = state?.fhirArrData;
    console.log("Data in dicom main page", fhirData);
    if (fhirData) {
      setFhirArrays(fhirData);
    }
  }, []);
  useEffect(() => {
    if (fhirArrays.length > 0) {
      console.log("fhirArray length", fhirArrays.length);
      var multiplefhirsArrays = [];
      fhirArrays.map((fhirArray) => {
        var fhirObj = fhirArray?.contentObj;
        var diagEnityArr = fhirObj?.entry?.filter((org) =>
          org?.fullUrl.includes("DiagnosticReport")
        );
        var composEnityArr = fhirObj?.entry?.filter((org) =>
          org?.fullUrl.includes("Composition")
        );
        var mediaEnityArr = fhirObj?.entry?.filter((org) =>
          org?.fullUrl.includes("Media")
        );
        // console.log(diagEnityArr, composEnityArr, mediaEnityArr);
        // var mediaArray = [];
        //   if (mediaEnityArr !== undefined && mediaEnityArr.length > 0) {
        //     mediaEnityArr.map((mediaEnityObj) => {
        //       mediaArray.push(mediaEnityObj?.resource?.content);
        //     });
        //   }
        // console.log(mediaEnityArr);
        if (
          diagEnityArr !== undefined &&
          diagEnityArr.length > 0 &&
          composEnityArr !== undefined &&
          composEnityArr.length > 0
        ) {
          console.log("Inside if");
          var singleFhirObjectEleArrays = [];
          diagEnityArr.map((diagEnityObj) => {
            var diagnosticRepotfullUrl = diagEnityObj?.fullUrl;
            console.log(diagnosticRepotfullUrl);
            var compositionSection =
              composEnityArr?.length > 0 &&
              composEnityArr[0]?.resource?.section;
            // console.log("Composition Section", compositionSection);
            var compositionArr =
              compositionSection?.length > 0 &&
              compositionSection?.filter((compSec) =>
                compSec?.entry.some((entryObj) =>
                  entryObj?.reference?.includes(diagnosticRepotfullUrl)
                )
              );

            // console.log("Composition Arr", compositionArr);
            var compositionTitle =
              compositionArr?.length > 0 ? compositionArr[0]?.title : "";
            var obsResultArr = diagEnityObj?.resource?.result;
            var conclusionArr = diagEnityObj?.resource?.conclusion;
            var mediaArr = [];
            console.log("Yes");
            if (diagEnityObj?.resource?.media) {
              console.log("Yes2");
              diagEnityObj.resource.media.forEach((med) => {
                const mediaReference = med.link.reference;
                // console.log(mediaReference);
                // Assuming fullUrl is the property you want to match against
                const matchingMedia = mediaEnityArr.find(
                  (media) => media.fullUrl === mediaReference
                );

                if (matchingMedia) {
                  mediaArr.push(matchingMedia);
                }
              });
            }
            var presentedFormArr = diagEnityObj?.resource?.presentedForm;
            if (obsResultArr !== undefined && obsResultArr.length > 0) {
              var observationsPerDiagnosticArr = [];
              for (var i = 0; i < obsResultArr.length; i++) {
                var obArr = fhirObj?.entry?.filter(
                  (org) => org?.fullUrl === obsResultArr[i]?.reference
                )[0];
                observationsPerDiagnosticArr.push(obArr);
              }
            }
            singleFhirObjectEleArrays.push({
              observationsArray:
                observationsPerDiagnosticArr &&
                observationsPerDiagnosticArr.length > 0
                  ? observationsPerDiagnosticArr
                  : [],
              conclusions: conclusionArr ? conclusionArr : "",
              attachmentArray:
                presentedFormArr && presentedFormArr.length > 0
                  ? presentedFormArr
                  : [],
              mediaArray: mediaArr && mediaArr.length > 0 ? mediaArr : [],
              compositionTitle:
                compositionTitle !== undefined ? compositionTitle : "",
            });
          });
          // console.log("Dicom main page Single Fhir", singleFhirObjectEleArrays);
          multiplefhirsArrays.push({
            singleFhirObjectEleArrays,
          });
        }
      });

      console.log("Diacom Main page", multiplefhirsArrays);
      setData(multiplefhirsArrays);
    }
  }, [fhirArrays]);
  const history = useHistory();
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const Token = () => {
    const check = CheckToken();
    setAuthToken(sessionStorage.getItem("accessToken"));
    return check;
  };
  console.log("Data variable", data);
  return (
    <>
      <div className={styles["console-main"]} style={{ margin: "10px" }}>
        <div className={styles["timeline-container"]}>
          <PillNav state={state} />
          {data !== null && data.length > 0 && <Dicom data={data} />}
        </div>
        <div style={{ margin: "15px" }}>
          <PatientCard patientData={stateVal ? stateVal.patientData : {}} />
        </div>
        {/* ... Other parts of your component ... */}
      </div>
    </>
  );
};

export default DicomMain;
